import { FirebaseMessaging } from "@capacitor-firebase/messaging";
import { App as CapApp } from "@capacitor/app";
import { Capacitor, PermissionState } from "@capacitor/core";
import { registerDevice } from "../api";

/**
 * Нативные пуши в Capacitor-приложении. Доступны, если при сборке бренда
 * в нативные проекты положены конфиги Firebase (scripts/set-brand.js).
 */
export const isNativePushAvailable = (): boolean =>
  Capacitor.isNativePlatform() && process.env.REACT_APP_NATIVE_PUSH === "1";

const toPermission = (state: PermissionState): NotificationPermission => {
  if (state === "granted") return "granted";
  if (state === "denied") return "denied";
  return "default";
};

export const getNativePushPermission =
  async (): Promise<NotificationPermission> => {
    const { receive } = await FirebaseMessaging.checkPermissions();
    return toPermission(receive);
  };

export const registerNativeToken = async (token: string): Promise<void> => {
  const { version } = await CapApp.getInfo();

  await registerDevice({
    token,
    platform: Capacitor.getPlatform() === "ios" ? "ios" : "android",
    app_version: version,
  });
};

export const syncNativePushToken = async (): Promise<boolean> => {
  if ((await getNativePushPermission()) !== "granted") {
    return false;
  }

  const { token } = await FirebaseMessaging.getToken();
  await registerNativeToken(token);

  return true;
};

export const enableNativePush = async (): Promise<NotificationPermission> => {
  const { receive } = await FirebaseMessaging.requestPermissions();
  const permission = toPermission(receive);

  if (permission === "granted") {
    await syncNativePushToken();
  }

  return permission;
};
